import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

const reactPlugin = new ReactPlugin();

const connectionString = "InstrumentationKey=32c7365f-b101-465d-82e1-6877ff5cc836;IngestionEndpoint=https://norwayeast-0.in.applicationinsights.azure.com/;LiveEndpoint=https://norwayeast.livediagnostics.monitor.azure.com/;ApplicationId=4c1172a2-1363-43ea-bfaa-bb573ac09de9";
const hasValidConnectionString = connectionString && connectionString.trim() !== '';

let appInsights: ApplicationInsights | null = null;

if (hasValidConnectionString) {
  appInsights = new ApplicationInsights({
    config: {
      connectionString: connectionString,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: {}
      },
      enableAutoRouteTracking: true,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      disableFetchTracking: false,
      enableAjaxErrorStatusText: true,
      enableUnhandledPromiseRejectionTracking: true,
    }
  });
} else {
  console.log('Application Insights not initialized - no valid connection string provided');
}

export { appInsights, reactPlugin };
